export default `<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="-1 0 28 25">
    <g>
        <rect x="0.26" y="8.65" width="4.97" height="16.15"/>
        <path d="M3,.2A2.88,2.88,0,0,0-.11,3.06a3,3,0,0,0,3,3.11h0A3.07,3.07,0,0,0,6,3.06,2.77,2.77,0,0,0,3,.2Z"/>
        <path d="M18.77,7.78c-3,0-3.6,1.74-4.84,2.86v-2H9.33c.12,1.24,0,16.15,0,16.15h4.6V15.61a4.4,4.4,0,0,1,.37-1.37,2.71,2.71,0,0,1,2.61-2c2,0,3.23,1.49,3.23,3.73V24.8h5V15.36C25.11,10.26,22.38,7.78,18.77,7.78Z"/>
    </g>
</svg>`;
